import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isPlainObject } from 'lodash';
import { TBaseDataItem, TBaseDataObject } from '../../types';
import { TUiState } from '../types';
import { ApiRequestSucceed } from '../saga/api/actions';
import { ILocalStorageData } from '../saga/localStorage/actions';

const COLLECTION_WHITELIST: Record<string, RegExp[]> = {
  ui: [/^action$/],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    locale: 'ru',
    navigateTo: undefined,
    states: {},
    collections: {},
  } as TUiState,
  reducers: {
    setLocale: (state, { payload }: PayloadAction<string>) => {
      if (!payload || typeof payload !== 'string') return;
      state.locale = payload;
    },
    setNavigateTo: (state, { payload }: PayloadAction<string | undefined>) => {
      state.navigateTo = payload;
    },
    setCustomState: (
      state,
      { payload }: PayloadAction<{ name: string; value: TBaseDataItem | TBaseDataObject | TBaseDataItem[] | TBaseDataObject[] }>
    ) => {
      state.states[payload.name] = payload.value;
    },
  },
  extraReducers(builder) {
    builder
      .addCase('localStorage/loaded' as const, (state, action) => {
        const { payload } = action as PayloadAction<ILocalStorageData>;
        if (payload.states && isPlainObject(payload.states)) {
          for (const [key, value] of Object.entries(payload.states)) {
            state.states[key] = value as TBaseDataItem | TBaseDataObject | TBaseDataItem[] | TBaseDataObject[];
          }
        }
      })
      .addCase(ApiRequestSucceed, (state, { payload }) => {
        if (!isPlainObject(payload.data)) return;

        const data = payload.data as Record<string, Record<string, unknown>>;
        const newUi = data.ui;
        if (!newUi) return;

        const patterns = COLLECTION_WHITELIST.ui;
        const filtered = Object.fromEntries(
          Object.entries(newUi).filter(([key]) => patterns.some(re => re.test(key)))
        );

        Object.assign(state, filtered);
      });
  },
});

export const { setLocale, setNavigateTo, setCustomState } = uiSlice.actions;
export default uiSlice.reducer;
